// ** Bars Icons Data

export const barsIcons = {
	bars: {
		viewBox: "0 0 448 512",
		variants: {
			light: {
				"data-prefix": "fal",
				"data-icon": "bars",
				source: "https://fontawesome.com/icons/bars",
				license: "https://fontawesome.com/license",
				path: "M442 114H6a6 6 0 0 1-6-6V84a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6zm0 160H6a6 6 0 0 1-6-6v-24a6 6 0 0 1 6-6h436a6 6 0 0 1 6 6v24a6 6 0 0 1-6 6z",
			},
			solid: {
				"data-prefix": "fas",
				"data-icon": "bars",
				source: "https://fontawesome.com/icons/bars",
				license: "https://fontawesome.com/license",
				path: "M16 132h416c8.837 0 16-7.163 16-16V76c0-8.837-7.163-16-16-16H16C7.163 60 0 67.163 0 76v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16zm0 160h416c8.837 0 16-7.163 16-16v-40c0-8.837-7.163-16-16-16H16c-8.837 0-16 7.163-16 16v40c0 8.837 7.163 16 16 16z",
			},
		},
	},
};
